import { createApp } from "vue";
import VueGtag from "vue-gtag";
import App from "./App.vue";
import router from "./router";
import store from "./store";

createApp(App)
  .use(router)
  .use(store)
  .use(
    VueGtag,
    {
      config: {
        id: "G-XWXF08QN1T",
      },
    },
    router
  )
  .mount("#app");
